import {getUseQueryResultData, useGetTicketMappingIdsQuery} from "@ots-frontend/ots-data";
import {BaseTicketMappingIdSelect, BaseTicketMappingIdSelectProps} from "./BaseTicketMappingIdSelect";
import {useMemo} from "react";
import {createSelector} from "reselect";

const selector = () => createSelector(
  [getUseQueryResultData<string[]>],
  (data) => {
      return data ?? [];
  }
);

type Props = Omit<BaseTicketMappingIdSelectProps, "data" | "loading">

export const TicketMappingIdSelect = (props: Props) => {
    const {...rest} = props;

    const selectMappingIds = useMemo(() => {
        return selector()
    }, [])

    const {data, isLoading} = useGetTicketMappingIdsQuery(undefined, {
        selectFromResult: (result) => ({
            data: selectMappingIds(result),
            isLoading: result.isLoading,
        })
    });

    return <BaseTicketMappingIdSelect data={data} loading={isLoading} {...rest} />;
};
